import * as React from 'react';

import { useLocalization } from '@shared-ui/localization-context';

import { RoomViewModel } from 'models';

import { BeddingOptions } from './bedding-options';

export interface RoomInfoCrawlableProps {
  room: RoomViewModel;
}

export const RoomInfoCrawlable = (props: RoomInfoCrawlableProps) => {
  const { formatText } = useLocalization();
  const { room } = props;

  if (!room) {
    return null;
  }

  const { beddingOptions, description, maxOccupancy } = room;
  const showBeddingOptions = beddingOptions && beddingOptions.length > 0;
  const showMaxOccupancy = maxOccupancy && (maxOccupancy.people || maxOccupancy.adults || maxOccupancy.children);

  return (
    <div className="is-hidden room-info-crawlable__wrapper">
      {(showBeddingOptions || showMaxOccupancy || description) && <h2>{formatText('hotels.infosite.roomInfoDialog.title')}</h2>}

      {showBeddingOptions && (
        <>
          <h3>{formatText('hotels.infosite.roomInfoDialog.bedDetails.title.sentenceCase')}</h3>
          <BeddingOptions options={beddingOptions} />
        </>
      )}

      {showMaxOccupancy && (
        <>
          <h3>{formatText('hotels.infosite.roomInfoDialog.sleeps.title')}</h3>
          <ul className="no-bullet" data-stid="room-info-max-occupancy-list">
            {maxOccupancy.people && formatText('hotels.infosite.roomInfoDialog.maxPeople.text', maxOccupancy.people)}
            {maxOccupancy.adults && formatText('hotels.infosite.roomInfoDialog.maxAdults.text', maxOccupancy.adults)}
            {maxOccupancy.children && formatText('hotels.infosite.roomInfoDialog.maxChildren.text', maxOccupancy.children)}
          </ul>
        </>
      )}

      {description && (
        <>
          <h3>{formatText('hotels.infosite.roomInfoDialog.roomDetails.linkText')}</h3>
          <div dangerouslySetInnerHTML={{ __html: description }} />
        </>
      )}
    </div>
  );
};
